import script from "./AdminPosters.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPosters.vue?vue&type=script&setup=true&lang=js"

import "./AdminPosters.vue?vue&type=style&index=0&id=00b1f918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b1f918"]])

export default __exports__